import { render, staticRenderFns } from "./ClaimRequestList.vue?vue&type=template&id=6b87066c&"
import script from "./ClaimRequestList.vue?vue&type=script&lang=js&"
export * from "./ClaimRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ClaimRequestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports